var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processMonitoring"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Loading_Process'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Loading_quarter')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaLoadquarter,"otherData":{
          mediaName: '封柜过程(1/4)',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaLoadquarter',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Loading_half')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaLoadhalf,"otherData":{
          mediaName: '封柜过程(2/4)',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaLoadhalf',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Loading_three_quarter')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaLoadthreequarter,"otherData":{
          mediaName: '封柜过程(3/4)',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaLoadthreequarter',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Loading_Finished')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaLoadfinish,"otherData":{
          mediaName: '全部装完',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaLoadfinish',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Right_Door_Closed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaRightclose,"otherData":{
          mediaName: '右侧柜门关闭',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaRightclose',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Both_Door_Closed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaBothclose,"otherData":{
          mediaName: '双侧柜门关闭',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaBothclose',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Container_Sealing_Photo')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.processMonitoring.lmediaSealphoto,"otherData":{
          mediaName: '封柜照片',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSealphoto',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",staticStyle:{"margin-right":"20px"},attrs:{"columns":_vm.columns,"dataSource":[_vm.data],"bordered":"","pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }